<template>
  <div class="stat-card" :class="{ accent }">
    <div class="stat-head">
      <span class="stat-label">{{ label }}</span>
      <span v-if="icon" class="stat-icon"><nav-icon :name="icon" :size="16" /></span>
    </div>
    <div class="stat-value"><slot>{{ value }}</slot></div>
    <div v-if="sub || $slots.sub" class="stat-sub"><slot name="sub">{{ sub }}</slot></div>
  </div>
</template>

<script>
import NavIcon from '../NavIcon.vue'

export default {
  name: 'StatCard',
  components: { NavIcon },
  props: {
    label: { type: String, default: '' },
    value: { type: [String, Number], default: '' },
    sub: { type: String, default: '' },
    icon: { type: String, default: '' },
    accent: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.stat-card {
  position: relative;
  background: var(--panel-bg);
  border: 1px solid var(--panel-border);
  border-radius: var(--radius-lg);
  padding: 15px 16px;
  overflow: hidden;
  transition: border-color 0.2s ease, transform 0.2s ease;
}
.stat-card:hover { border-color: rgba(var(--primary-rgb), 0.4); transform: translateY(-1px); }
.stat-card.accent::before {
  content: '';
  position: absolute;
  inset: 0 auto 0 0;
  width: 3px;
  background: var(--primary-color);
}
.stat-head { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.stat-label {
  font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px; color: var(--text-secondary);
}
.stat-icon { color: var(--text-secondary); opacity: 0.7; display: flex; }
.stat-value { font-size: 26px; font-weight: 700; color: var(--text-primary); margin: 6px 0 2px; line-height: 1.1; }
.stat-sub { font-size: 12px; color: var(--text-secondary); }
</style>
